'use client';

import {
  FieldValuesFromFieldErrors,
  ErrorMessage as HookErrorMessage,
} from '@hookform/error-message';
import {FieldErrors, FieldName} from 'react-hook-form';

interface ErrorMessageProps<T = FieldErrors> {
  errors: T;
  name: FieldName<FieldValuesFromFieldErrors<T>>;
}

export const FieldErrorMessage = ({errors, name}: ErrorMessageProps) => {
  return (
    <HookErrorMessage
      name={name}
      errors={errors}
      render={({message}) => <div className="mt-1 text-error-primary text-sm">{message}</div>}
    />
  );
};
